import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { useState } from 'react';
import { useHomeStyles } from '../styles/home';
import axios from 'axios';
import CircularProgress from '@material-ui/core/CircularProgress'
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'

const validationSchema = yup.object().shape({
   name: yup
     .string()
     .min(2, 'Minimum 2 characters length')
     .max(22, 'Maximum 16 characters length')
     .required('Name is required'),
   twitch: yup
     .string()
     .required('twitch username required'),
   email: yup
     .string()
     .email('Enter a valid email')
     .required('Email is required'),
});

const getModalStyle = () => {
   const top = 50;
   const left = 50;
 
   return {
     top: `${top}%`,
     left: `${left}%`,
     transform: `translate(-${top}%, -${left}%)`,
   };
}

interface RSVPFormProps {
   handleClose: () => unknown
   minted: string
   subject: string
}

type Inputs = {
   name: string,
   twitch: string,
   email: string,
};

export const RSVPForm = (props: RSVPFormProps) => {
   const { handleClose, minted, subject } = props;
   const [modalStyle] = useState(getModalStyle);
   const [isLoading, setIsLoading] = useState<boolean>(false);
   const classes = useHomeStyles();

   const { handleSubmit, control, reset } = useForm<Inputs>({
      resolver: yupResolver(validationSchema)
   });
   const onSubmit: SubmitHandler<Inputs> = data => execute(data);
 
   const execute = (data: Inputs) => {
      setIsLoading(true);
      axios.post('https://lasvegasvp-mail.herokuapp.com/send', {
         ...data,
         minted,
         subject
      })
      .then((response) => {
         reset();
         setIsLoading(false);
         handleClose();
      }).catch((error) => {
         console.log(error);
         setIsLoading(false);
      });
   };

   return (
      <div style={modalStyle} className={classes.modalPaper}>
         <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
         >
            <Grid item xs={12}>
            <Typography variant="h4" style={{ margin: '10px 0 20px'}}>
               <strong>RSVP For Next Event</strong>
            </Typography>
            </Grid>
            <form 
               className={classes.root} 
               noValidate 
               autoComplete="off"
               onSubmit={handleSubmit(onSubmit)}
               style={{ width: '100%' }}
            >
               <Grid item xs={12}>
                  <Controller
                     control={control}
                     name="name"
                     render={({ field, fieldState }) => (
                        <>
                        <FormControl variant="standard" fullWidth style={{ marginBottom: 30 }}>
                           <TextField   
                              id="outlined-error"
                              label="Name"
                              defaultValue=""
                              variant="outlined"
                              {...field}
                              error={Boolean(fieldState.error)}
                              disabled={isLoading}
                              style={{ width: '100%', margin: 0 }}
                           />
                           {Boolean(fieldState.error) &&
                              <FormHelperText id="component-helper-text" data-test="name-error">
                                 {fieldState.error?.message}
                              </FormHelperText>
                           }
                        </FormControl>
                        </>
                     )}
                  />
               </Grid>
               <Grid item xs={12}>
                  <Controller
                     control={control}
                     name="twitch"
                     render={({ field, fieldState }) => (
                        <>
                           <FormControl variant="standard" fullWidth style={{ marginBottom: 30 }}>
                              <TextField
                                 id="outlined-error-helper-text"
                                 label="Twitch Username"
                                 defaultValue=""
                                 variant="outlined"
                                 {...field}
                                 error={Boolean(fieldState.error)}
                                 disabled={isLoading}
                                 style={{ width: '100%', margin: 0 }}
                              />
                              {Boolean(fieldState.error) &&
                                 <FormHelperText id="component-helper-text" data-test="name-error">
                                    {fieldState.error?.message}
                                 </FormHelperText>
                              }
                           </FormControl>
                        </>
                     )}
                  />
               </Grid>
               <Grid item xs={12}>
                  <Controller
                     control={control}
                     name="email"
                     render={({ field, fieldState }) => (
                        <>
                           <FormControl variant="standard" fullWidth style={{ marginBottom: 30 }}>
                              <TextField
                                 id="outlined-error-helper-text"
                                 label="Email Address"
                                 defaultValue=""
                                 variant="outlined"
                                 {...field}
                                 error={Boolean(fieldState.error)}
                                 disabled={isLoading}
                                 style={{ width: '100%', margin: 0 }}
                              />
                              {Boolean(fieldState.error) &&
                                 <FormHelperText id="component-helper-text" data-test="name-error">
                                    {fieldState.error?.message}
                                 </FormHelperText>
                              }
                           </FormControl>
                        </>
                     )}
                  />
               </Grid>

               <Button 
                  variant="contained" 
                  color="primary" 
                  type="submit" 
                  style={{ width: '100%', margin: 0 }}
                  disabled={isLoading}
               >
                  Submit
                  {isLoading &&
                     <CircularProgress size="1rem" style={{ marginLeft: 10 }}/>
                  }
               </Button>
            </form>
            {/* need name, twitch username, email and hidden input for the hash of one of the 6 nfts minted */}
         </Grid>
      </div>
   )
}